import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import Box from "react-raster";
import { Button, Heading, Input, Link, Paper, Text } from "src/components";
import { theme } from "src/config";
import { AuthStore, RoutingStore } from "src/stores";
import { Page } from "src/routes";
import { PasswordStrength } from "src/components";

interface IAcceptInviteParams {
  token: string;
}

export interface IAcceptInviteProps {
  authStore?: AuthStore;
  routingStore?: RoutingStore;
  params: IAcceptInviteParams; // This is injected so it has to be called match
}

export const AcceptInvite = inject(
  "authStore",
  "routingStore"
)(
  observer((props: IAcceptInviteProps): JSX.Element => {
    const { t, i18n } = useTranslation();
    const [token, setToken] = React.useState<string>("");
    const { acceptInvite, isLoggedIn } = props.authStore;
    const [result, setResult] = React.useState<any>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [password, setPassword] = React.useState<string>("");
    const [passwordRepeat, setPasswordRepeat] = React.useState<string>("");
    const [valid, setValid] = React.useState<boolean>(false);

    useEffect(() => {
      const { params } = props;
      setToken(params?.token);
    }, []);

    useEffect(() => {
      if (result == "success") {
        props.routingStore.push(`/${Page.Login}`);
      }
    }, [result]);

    const submit = async () => {
      setLoading(true);
      const res = await acceptInvite(token, password);
      setResult(res ? 'success' : res);
      setLoading(false);
    };

    return (
      <Paper $noShadow style={{...theme.paper.small, marginTop: '10vh'}} $center>

        <Box gridRowGap={theme.layout.gutter} display='flex' flexDirection='column'>
          <Heading type="h2">{t("welcome")}</Heading>
          <Heading type="h3">{t("before_enter_new_password")}</Heading>
          <Box>
            <hr />
          </Box>
          <Text>{t("new_password_requirements")}</Text>
          <Input
            type="password"
            label={t("password")}
            id="new-password"
            value={password}
            onChange={(value) => setPassword(value)}
            errorMessage={t("validation_error", { what: t("password") })}
          />
          <Input
            type="password"
            label={t("password_repeat")}
            id="repeat-password"
            value={passwordRepeat}
            onChange={(value) => setPasswordRepeat(value)}
            errorMessage={t("validation_error", { what: t("password") })}
          />
        <PasswordStrength
            password={password}
            passwordRepeat={passwordRepeat}
            onValidate={(v) => setValid(v)}
          />
          <Text type={result}>{t(result)}</Text>
          <Box justifyContent="right">
            <Button
              size="large"
              variant="primary"
              onClick={(e) => submit()}
              isLoading={loading}
              disabled={!valid}
            >
              {t("send")}
            </Button>
          </Box>
        </Box>
      </Paper>
    );
  })
);
